import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { maxBy } from 'lodash';

import { withTranslation } from 'react-i18next';

// HighCharts
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';

// ui
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import DateFnsUtils from '@date-io/moment';
import {
  DatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';

// config highchart
Highcharts.setOptions({
  lang: {
    thousandsSep: ',',
  },
});

// export const t = (text) => <Trans>{text}</Trans>;

const currentYear = moment().year();
const yearsRange = (start, end) => Array.from({
  length: (start - end),
}, (v, k) => (start - k).toString());
const years = yearsRange(currentYear, 2011);
const yearsForRainfallYearly = yearsRange(currentYear - 1, 2011);

class RainfallChart extends Component {
  constructor(props) {
    super(props);

    // calculate enddate if time after 8AM set enddate minus 1
    let enddate;
    const currentTime = moment(new Date(), 'hh:mm');
    const beforeTime = moment('00:00', 'hh:mm');
    const afterTime = moment('08:00', 'hh:mm');
    if (currentTime.isBetween(beforeTime, afterTime)) {
      enddate = moment(new Date()).locale('th').subtract(2, 'day').format('YYYY-MM-DD');
    } else {
      enddate = moment(new Date()).locale('th').subtract(1, 'day').format('YYYY-MM-DD');
    }

    this.state = {
      isLoading: false,
      error: null,
      id: props.id,
      max: 0,
      chartOptions: this.getChartOptions('rainfall24h'),
      dataProvince: [],
      provinceId: props.provinceId,
      stations: props.filterData,
      teleStation: [],
      startDate: moment().subtract(7, 'days').locale('th').format('YYYY-MM-DD'),
      endDate: enddate,
      today: moment(new Date()).locale('th').format('YYYY-MM-DD'),
      type: props.selectedType,
      dataSeries: [],
      dataSeries2: [],
      yearSelect: props.year,
      monthSelect: props.month,
      limitDateRange: '',
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    const { selectedType } = this.props;
    this.getProvince();
    this.getStation();
    this.setState({ type: selectedType }, () => {
      this.renderChart();
    });
  }

  getChartOptions(type) {
    const { t } = this.props;
    let formatDateX = '{value:%d-%b<br />%H:%M}';
    let formatDateTooltip = '%d %B %y %H:%m น.';
    if (type === 'rainfallMonth' || type === 'rainfallYesterday') {
      formatDateX = '{value:%d-%b-%y}';
    }
    if (type === 'rainfallMonth' || type === 'rainfallYesterday' || type === 'rainfall3day' || type === 'rainfall7day') {
      formatDateTooltip = '%d %B %Y';
      formatDateX = '{value:%d-%b-%y}';
    }
    if (type === 'rainfallYear') {
      formatDateTooltip = '%B %Y';
      formatDateX = '{value:%b-%y}';
    }

    this.options = {
      title: {
        text: '',
      },
      plotOptions: {
        line: {
          turboThreshold: 0,
        },
      },
      xAxis: {
        type: 'datetime',
        labels: {
          format: formatDateX,
        },
      },
      yAxis: {
        title: {
          enabled: true,
          text: t('ปริมาณฝน (มม.)'),
        },
        minorGridLineWidth: 0,
        gridLineWidth: 1,
        alternateGridColor: null,
        labels: {
          format: '{value:.1f}',
        },
      },
      legend: {
        enabled: true,
      },
      tooltip: {
        crosshairs: true,
        shared: true,
        valueSuffix: t(' มม.'),
        xDateFormat: formatDateTooltip,
      },
      series: [
        {
          name: '',
          data: [],
          type: 'column',
          color: '#0066FF',
          tooltip: {
            valueSuffix: t(' มม.'),
            format: '{value:.1f}',
          },
        },
        {
          name: '',
          data: [],
          type: 'spline',
          tooltip: {
            valueSuffix: t(' มม.'),
            format: '{value:.1f}',
          },
        },
      ],
    };

    return this.options;
  }

  getChartOptions2(type) {
    const { t } = this.props;
    let formatDateX = '{value:%d-%b<br />%H:%M}';
    let formatDateTooltip = '%d %B %y %H:%m น.';
    if (type === 'rainfallMonth' || type === 'rainfallYesterday') {
      formatDateX = '{value:%d-%b-%y}';
    }
    if (type === 'rainfallMonth' || type === 'rainfallYesterday' || type === 'rainfall3day' || type === 'rainfall7day') {
      formatDateTooltip = '%d %B %Y';
    }
    if (type === 'rainfallYear') {
      formatDateTooltip = '%B %Y';
    }

    this.options = {
      title: {
        text: '',
      },
      plotOptions: {
        line: {
          turboThreshold: 0,
        },
      },
      xAxis: {
        type: 'datetime',
        labels: {
          format: formatDateX,
        },
      },
      yAxis: {
        title: {
          enabled: true,
          text: t('ปริมาณฝน (มม.)'),
        },
        minorGridLineWidth: 0,
        gridLineWidth: 1,
        alternateGridColor: null,
        labels: {
          format: '{value:.1f}',
        },
      },
      legend: {
        enabled: true,
      },
      tooltip: {
        crosshairs: true,
        shared: true,
        valueSuffix: t(' มม.'),
        xDateFormat: formatDateTooltip,
      },
      series: [
        {
          name: '',
          data: [],
          type: 'column',
          color: '#0066FF',
          tooltip: {
            valueSuffix: t(' มม.'),
            format: '{value:.1f}',
          },
        },
        // {
        //   name: '',
        //   data: [],
        //   type: 'spline',
        //   tooltip: {
        //     valueSuffix: ' มม.',
        //     format: '{value:.1f}',
        //   },
        // },
      ],
    };

    return this.options;
  }

  getStation() {
    this.setState({ isLoading: true });
    const {
      provinceId, id, type, stations,
    } = this.state;
    const teleStation = [];
    const teleStationAll = [];
    const selectedType = type;

    if (selectedType === 'rainfallMonth' || selectedType === 'rainfallYear' || selectedType === 'rainfallYesterday' || selectedType === 'rainfall3day' || selectedType === 'rainfall7day') {
      stations.map((row) => {
        if (selectedType === 'rainfallMonth' || selectedType === 'rainfallYear' || selectedType === 'rainfall3day' || selectedType === 'rainfall7day') {
          if (row.geocode.province_code === provinceId) {
            teleStation.push(row.station);
          }
          teleStationAll.push(row.station);
        }
        if (selectedType === 'rainfallYesterday') {
          if (row.province_code === provinceId) {
            teleStation.push(row);
          }
          teleStationAll.push(row);
        }
        return null;
      });
      if (!id) {
        if (teleStation.length > 0) {
          if (selectedType === 'rainfallMonth' || selectedType === 'rainfallYear' || selectedType === 'rainfall3day' || selectedType === 'rainfall7day') {
            this.handleStationChangeDefault(teleStation[0].id);
          }
          if (selectedType === 'rainfallYesterday') {
            this.handleStationChangeDefault(teleStation[0].tele_station_id);
          }
        }
      }
      this.setState({
        teleStation,
        isLoading: false,
      });
      this.renderChart();
    } else {
      fetch(`${process.env.REACT_APP_API_URL}/public/thailand_main_rain?province_code=${provinceId}`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((result) => {
          result.data.map((row) => {
            if (row.agency.agency_shortname.en !== 'DWR') {
              teleStation.push(row.station);
            }
            teleStationAll.push(row.station);
            return null;
          });
          if (!id) {
            if (teleStation.length > 0) {
              this.setState({
                id: teleStation[0].id,
              });
            }
          }
          this.setState({
            teleStation,
            isLoading: false,
          });
          this.renderChart();
        })
        .catch((error) => this.setState({ error, isLoading: false }));
    }
  }

  getProvince() {
    this.setState({ isLoading: true });
    fetch(`${process.env.REACT_APP_API_URL}/public/waterlevel_load`)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Something went wrong ...');
      })
      .then((result) => {
        const dataProvince = result.province.data.sort((a, b) => a.province_name.th.localeCompare(b.province_name.th, 'th'));
        this.setState({
          dataProvince,
          isLoading: false,
        });
      })
      .catch((error) => this.setState({ error, isLoading: false }));
  }

  handleProvinceChange = (event) => {
    this.setState({ provinceId: event.target.value, id: '' }, () => {
      this.getStation();
    });
  };

  handleTypeChange = (event) => {
    this.setState({ type: event.target.value }, () => {
      this.renderChart();
    });
  };

  handleStationChangeDefault = (idNum) => {
    this.setState({ id: idNum }, () => {
      this.renderChart();
    });
  };

  handleStationChange = (event) => {
    this.setState({ id: event.target.value }, () => {
      this.renderChart();
    });
  };

  handleStartDateChange = (date) => {
    this.setState({ startDate: moment(date).format('YYYY-MM-DD') });
  };

  handleEndDateChange = (date) => {
    this.setState({ endDate: moment(date).format('YYYY-MM-DD') }, () => {
      this.renderChart();
    });
  };

  handleMonthChange = (event) => {
    this.setState({ monthSelect: event.target.value }, () => {
      this.renderChart();
    });
  };

  handleYearChange = (event) => {
    this.setState({ yearSelect: event.target.value }, () => {
      this.renderChart();
    });
  };

  renderChart = () => {
    const { t } = this.props;
    const {
      id, type, startDate, endDate, yearSelect, monthSelect,
    } = this.state;
    this.setState({ isLoading: true });

    let link = 'rain_24h_graph';
    if (type === 'rainfall24h') {
      fetch(
        `${process.env.REACT_APP_API_URL}/public/${link}?station_id=${id}`,
      ).then((response) => {
        if (response.ok) {
          return response.json();
        }
        return 'Something went wrong.';
      })
        .then((result) => {
          const ds1 = [];
          const ds2 = [];
          let ts = null;
          let val = null;
          let val2 = 0;

          const max = maxBy(result.data, 'rainfall_value') === undefined ? 0 : maxBy(result.data, 'rainfall_value').value;
          this.setState({
            max,
          });

          result.data.map((n) => {
            val = ((n.rainfall_value) === '' || (n.rainfall_value) === null) ? null : (parseFloat(n.rainfall_value).toFixed(2)) * 1;

            ts = moment(n.rainfall_datetime, 'YYYY/MM/DD hh:mm:ss').add(7, 'hours').valueOf();

            ds1.push([ts, val]);

            val2 = (val >= 0) ? (parseFloat(val + val2).toFixed(2) * 1) : null;

            ds2.push([ts, val2]);

            this.setState({ dataSeries: ds1, dataSeries2: ds2 });

            return null;
          });
          // const { dataSeries2, dataSeries } = this.state;
          const { dataSeries } = this.state;
          const chartOptions = this.getChartOptions2(type);
          chartOptions.series[0].data = dataSeries;
          chartOptions.series[0].name = t('ปริมาณฝนรายชั่วโมง');
          // chartOptions.series[1].data = dataSeries2;
          // chartOptions.series[1].name = 'ปริมาณสะสม 24 ชั่วโมง';

          this.setState({ chartOptions, isLoading: false });
        })
        .catch((error) => this.setState({ error, isLoading: false }));
    } else if (type === 'rainfallToday') {
      link = 'rain_today_graph';
      fetch(
        `${process.env.REACT_APP_API_URL}/public/${link}?station_id=${id}`,
      ).then((response) => {
        if (response.ok) {
          return response.json();
        }
        return 'Something went wrong.';
      })
        .then((result) => {
          if (result.result === 'OK') {
            const dataSeries = [];
            let ts = null;
            let val = null;

            const max = maxBy(result.data, 'rainfall') === undefined ? 0 : maxBy(result.data, 'rainfall').value;
            this.setState({
              max,
            });

            result.data.map((n) => {
              val = ((n.rainfall) === '' || (n.rainfall) === null) ? null : (parseFloat(n.rainfall).toFixed(2)) * 1;
              // val = (parseFloat(n.rainfall).toFixed(2)) * 1;
              ts = moment(n.date_time, 'YYYY/MM/DD hh:mm:ss').add(7, 'hours').valueOf();
              dataSeries.push([ts, parseFloat(val)]);
              return null;
            });

            const chartOptions = this.getChartOptions2(type);
            chartOptions.series[0].data = dataSeries;
            chartOptions.series[0].name = t('ปริมาณฝนวันนี้');
            // chartOptions.series[1].visible = false;

            this.setState({ chartOptions, isLoading: false });
          } else {
            const chartOptions = 0;
            this.setState({ chartOptions, isLoading: false });
          }
        })
        .catch((error) => this.setState({ error, isLoading: false }));
    } else if (type === 'rainfallYesterday') {
      link = 'rain_yesterday_graph';
      fetch(
        `${process.env.REACT_APP_API_URL}/public/${link}?station_id=${id}&start_date=${startDate}&end_date=${endDate}`,
      ).then((response) => {
        if (response.ok) {
          return response.json();
        }
        return 'Something went wrong.';
      })
        .then((result) => {
          if (result.result === 'OK') {
            const ds1 = [];
            const ds2 = [];
            let ts = null;
            let val = null;
            let val2 = 0;

            const max = maxBy(result.data, 'rainfall_value') === undefined ? 0 : maxBy(result.data, 'rainfall_value').value;
            this.setState({
              max,
            });

            result.data.map((n) => {
              val = ((n.rainfall_value) === '' || (n.rainfall_value) === null) ? null : (parseFloat(n.rainfall_value).toFixed(2)) * 1;
              ts = moment(n.rainfall_datetime, 'YYYY/MM/DD hh:mm:ss').add(7, 'hours').valueOf();
              ds1.push([ts, val]);
              val2 = (val >= 0) ? (parseFloat(val + val2).toFixed(2) * 1) : null;
              ds2.push([ts, val2]);
              this.setState({ dataSeries: ds1, dataSeries2: ds2 });
              return null;
            });

            const { dataSeries2, dataSeries } = this.state;
            const chartOptions = this.getChartOptions(type);
            chartOptions.series[0].data = dataSeries;
            chartOptions.series[0].name = t('ปริมาณฝนรายวัน');
            chartOptions.series[1].data = dataSeries2;
            chartOptions.series[1].name = t('ปริมาณฝนสะสมรายวัน');

            this.setState({ chartOptions, isLoading: false, limitDateRange: '' });
          } else {
            const chartOptions = 0;

            let limitDateRange = '';

            if (
              result?.data?.RespCode === 422
              && result?.data?.RespMessage === 'limit date range'
            ) {
              limitDateRange = t('กรุณาเลือกช่วงวันที่ไม่เกิน 31 วัน');
            }

            this.setState({ chartOptions, limitDateRange, isLoading: false });
          }
        })
        .catch((error) => this.setState({ error, isLoading: false }));
    } else if (type === 'rainfall3day') {
      fetch(
        `${process.env.REACT_APP_API_URL}/provinces/rain3d_graph?station_id=${id}&start_date=${startDate}&end_date=${moment(endDate).add(1, 'day').format('YYYY-MM-DD')}`,
      ).then((response) => {
        if (response.ok) {
          return response.json();
        }
        return 'Something went wrong.';
      })
        .then((result) => {
          if (result.result === 'OK') {
            const ds1 = [];
            let ts = null;
            let val = null;

            const max = maxBy(result.data, 'rainfall_value') === undefined ? 0 : maxBy(result.data, 'rainfall_value').value;
            this.setState({
              max,
            });

            result.data.map((n) => {
              val = ((n.rainfall_value) === '' || (n.rainfall_value) === null) ? null : (parseFloat(n.rainfall_value).toFixed(2)) * 1;
              ts = moment(n.rainfall_datetime, 'YYYY/MM/DD hh:mm:ss').subtract(17, 'hours').valueOf();

              ds1.push([ts, val]);
              this.setState({ dataSeries: ds1 });
              return null;
            });

            const { dataSeries } = this.state;
            const chartOptions = this.getChartOptions2(type);
            chartOptions.series[0].data = dataSeries;
            chartOptions.series[0].name = t('ปริมาณฝนสะสม 3 วัน');

            this.setState({ chartOptions, isLoading: false, limitDateRange: '' });
          } else {
            const chartOptions = 0;

            let limitDateRange = '';

            if (
              result?.data?.RespCode === 422
              && result?.data?.RespMessage === 'limit date range'
            ) {
              limitDateRange = t('กรุณาเลือกช่วงวันที่ไม่เกิน 31 วัน');
            }

            this.setState({ chartOptions, limitDateRange, isLoading: false });
          }
        })
        .catch((error) => this.setState({ error, isLoading: false }));
    } else if (type === 'rainfall7day') {
      fetch(
        `${process.env.REACT_APP_API_URL}/provinces/rain7d_graph?station_id=${id}&start_date=${startDate}&end_date=${moment(endDate).add(1, 'day').format('YYYY-MM-DD')}`,
      ).then((response) => {
        if (response.ok) {
          return response.json();
        }
        return 'Something went wrong.';
      })
        .then((result) => {
          if (result.result === 'OK') {
            const ds1 = [];
            const ds2 = [];
            let ts = null;
            let val = null;
            let val2 = 0;

            const max = maxBy(result.data, 'rainfall_value') === undefined ? 0 : maxBy(result.data, 'rainfall_value').value;
            this.setState({
              max,
            });

            result.data.map((n) => {
              val = ((n.rainfall_value) === '' || (n.rainfall_value) === null) ? null : (parseFloat(n.rainfall_value).toFixed(2)) * 1;
              // ts = moment(n.rainfall_datetime, 'YYYY/MM/DD hh:mm:ss').add(7, 'hours').valueOf();
              ts = moment(n.rainfall_datetime, 'YYYY/MM/DD hh:mm:ss').subtract(17, 'hours').valueOf();
              ds1.push([ts, val]);
              val2 = (val >= 0) ? (parseFloat(val + val2).toFixed(2) * 1) : null;
              ds2.push([ts, val2]);
              this.setState({ dataSeries: ds1, dataSeries2: ds2 });
              return null;
            });

            const { dataSeries } = this.state;
            const chartOptions = this.getChartOptions2(type);
            chartOptions.series[0].data = dataSeries;
            chartOptions.series[0].name = t('ปริมาณฝนสะสม 7 วัน');

            this.setState({ chartOptions, isLoading: false, limitDateRange: '' });
          } else {
            const chartOptions = 0;

            let limitDateRange = '';

            if (
              result?.data?.RespCode === 422
              && result?.data?.RespMessage === 'limit date range'
            ) {
              limitDateRange = t('กรุณาเลือกช่วงวันที่ไม่เกิน 31 วัน');
            }

            this.setState({ chartOptions, limitDateRange, isLoading: false });
          }
        })
        .catch((error) => this.setState({ error, isLoading: false }));
    } else if (type === 'rainfallMonth') {
      link = 'rain_monthly_graph';
      fetch(
        `${process.env.REACT_APP_API_URL}/public/${link}?station_id=${id}&month=${monthSelect}&year=${yearSelect}`,
      ).then((response) => {
        if (response.ok) {
          return response.json();
        }
        return 'Something went wrong.';
      })
        .then((result) => {
          if (result.result === 'OK') {
            const ds1 = [];
            const ds2 = [];
            let ts = null;
            let val = null;
            let val2 = 0;

            const max = maxBy(result.data, 'rainfall_value') === undefined ? 0 : maxBy(result.data, 'rainfall_value').value;
            this.setState({
              max,
            });

            result.data.map((n) => {
              val = ((n.rainfall_value) === '' || (n.rainfall_value) === null) ? null : (parseFloat(n.rainfall_value).toFixed(2)) * 1;
              ts = moment(n.rainfall_datetime, 'YYYY/MM/DD').add(7, 'hours').valueOf();
              ds1.push([ts, val]);
              // val2 = (val >= 0) ? (parseFloat(val + val2).toFixed(2) * 1) : null;
              // Fix bugs, future day still show summary line
              val2 = (val >= 0 && (moment().diff(moment(n.rainfall_datetime, 'YYYY-MM_DD'), 'days')) >= 0) ? (parseFloat(val + val2).toFixed(2) * 1) : null;
              ds2.push([ts, val2]);
              this.setState({ dataSeries: ds1, dataSeries2: ds2 });
              return null;
            });

            const { dataSeries2, dataSeries } = this.state;
            const chartOptions = this.getChartOptions(type);
            chartOptions.series[0].data = dataSeries;
            chartOptions.series[0].name = t('ปริมาณฝน');
            chartOptions.series[1].data = dataSeries2;
            chartOptions.series[1].name = t('ปริมาณฝนสะสม');

            this.setState({ chartOptions, isLoading: false });
          } else {
            const chartOptions = 0;
            this.setState({ chartOptions, isLoading: false });
          }
        })
        .catch((error) => this.setState({ error, isLoading: false }));
    } else if (type === 'rainfallYear') {
      link = 'rain_yearly_graph';
      fetch(
        `${process.env.REACT_APP_API_URL}/public/${link}?station_id=${id}&year=${yearSelect}`,
      ).then((response) => {
        if (response.ok) {
          return response.json();
        }
        return 'Something went wrong.';
      })
        .then((result) => {
          if (result.result === 'OK') {
            const ds1 = [];
            const ds2 = [];
            let ts = null;
            let val = null;
            let val2 = 0;
            const max = maxBy(result.data, 'rainfall') === undefined ? 0 : maxBy(result.data, 'rainfall').value;
            this.setState({
              max,
            });

            result.data.map((n) => {
              val = ((n.rainfall) === '' || (n.rainfall) === null) ? null : (parseFloat(n.rainfall).toFixed(2)) * 1;
              val = (parseFloat(n.rainfall).toFixed(0)) * 1;
              // ts = moment(n.date_time, 'YYYY/MM/DD').valueOf();
              ts = moment(n.date_time, 'YYYY/MM/01').add(7, 'hours').valueOf();
              ds1.push([ts, val]);
              val2 = (val >= 0) ? (parseFloat(val + val2).toFixed(2) * 1) : null;
              ds2.push([ts, val2]);
              this.setState({ dataSeries: ds1, dataSeries2: ds2 });
              return null;
            });
            const { dataSeries2, dataSeries } = this.state;
            const chartOptions = this.getChartOptions(type);
            chartOptions.series[0].data = dataSeries;
            chartOptions.series[0].name = t('ปริมาณฝน');
            chartOptions.series[1].data = dataSeries2;
            chartOptions.series[1].name = t('ปริมาณฝนสะสม');

            this.setState({ chartOptions, isLoading: false });
          } else {
            const chartOptions = 0;
            this.setState({ chartOptions, isLoading: false });
          }
        })
        .catch((error) => this.setState({ error, isLoading: false }));
    }
  }

  render() {
    const {
      dataProvince,
      id,
      provinceId,
      teleStation,
      type,
      isLoading,
      error,
      chartOptions,
      max,
      startDate,
      endDate,
      today,
      yearSelect,
      monthSelect,
      limitDateRange,
    } = this.state;
    const {
      classes,
      t,
    } = this.props;

    // if error, show error message
    let errorMsg = '';
    if (error) {
      errorMsg = (
        <Paper className={classes.root} elevation={1}>
          <Typography component="p">
            {error}
          </Typography>
        </Paper>
      );
    }
    let chart = '';

    if (limitDateRange) {
      chart = (
        <div className={classes.paper}>
          {limitDateRange}
        </div>
      );
    } else if (chartOptions === 0 || max === 0) {
      chart = <div className={classes.paper}>{t('ไม่มีข้อมูล')}</div>;
    } else {
      chart = <HighchartsReact highcharts={Highcharts} options={chartOptions} />;
    }
    return (
      <>
        {errorMsg}
        <Grid container spacing={2} alignItems="flex-end">
          <Grid item xs sm={10}>
            <Grid container spacing={2}>
              {/* <Grid item xs sm>
                <FormControl className={classes.formControl} style={{ whiteSpace: 'nowrap' }}>
                  <InputLabel htmlFor="type">ประเภทข้อมูล</InputLabel>
                  <Select
                    value={type}
                    onChange={this.handleTypeChange}
                    inputProps={{
                      name: 'selectedType',
                      id: 'type',
                    }}
                    style={{ minWidth: 140 }}
                  >
                    { type === 'rainfall24h' && (
                      <MenuItem value="rainfall24h">ฝนสะสม 24 ชั่วโมง</MenuItem>
                    )}
                    { type === 'rainfallToday' && (
                      <MenuItem value="rainfallToday">ฝนวันนี้</MenuItem>
                    )}
                    { type === 'rainfallYesterday' && (
                      <MenuItem value="rainfallYesterday">ฝนวานนี้</MenuItem>
                    )}
                    { type === 'rainfall3day' && (
                      <MenuItem value="rainfall3day">ฝนสะสม 3 วัน</MenuItem>
                    )}
                    { type === 'rainfall7day' && (
                      <MenuItem value="rainfall7day">ฝนสะสม 7 วัน</MenuItem>
                    )}
                    { type === 'rainfallMonth' && (
                      <MenuItem value="rainfallMonth">ฝนรายเดือน</MenuItem>
                    )}
                    { type === 'rainfallYear' && (
                      <MenuItem value="rainfallYear">ฝนรายปี</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid> */}
              <Grid item xs sm>
                <FormControl className={classes.formControl}>
                  <InputLabel shrink htmlFor="province-label-placeholder">
                    {t('จังหวัด')}
                  </InputLabel>
                  <Select
                    id="rain-select-province"
                    value={provinceId}
                    onChange={this.handleProvinceChange}
                    style={{ minWidth: 140 }}
                  >
                    {dataProvince.map((row) => (
                      <MenuItem key={row.province_code} value={row.province_code}>
                        {t(row.province_name.th)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs sm>
                <FormControl className={classes.formControl}>
                  <InputLabel shrink htmlFor="station-label-placeholder">
                    {t('สถานี')}
                  </InputLabel>
                  <Select id="rain-select-id" value={id} onChange={this.handleStationChange} style={{ minWidth: 200 }}>
                    {(type === 'rainfallMonth' || type === 'rainfallYear') && (
                      teleStation.map((row) => (
                        <MenuItem key={row.id} value={row.id}>
                          {`${row.tele_station_name.th} (${row.tele_station_oldcode})`}
                        </MenuItem>
                      ))
                    )}
                    {(type === 'rainfall24h' || type === 'rainfallToday' || type === 'rainfall3day' || type === 'rainfall7day') && (
                      teleStation.map((row) => (
                        <MenuItem key={row.id} value={row.id}>
                          {`${row.tele_station_name.th} (${row.tele_station_oldcode})`}
                        </MenuItem>
                      ))
                    )}
                    {(type === 'rainfallYesterday') && (
                      teleStation.map((row) => (
                        <MenuItem key={row.tele_station_id} value={row.tele_station_id}>
                          {`${row.tele_station_name.th}`}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                </FormControl>
              </Grid>

              {type === 'rainfallMonth' && (
                <Grid item xs={6} sm={6} md={3}>
                  <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="type">{t('เดือน')}</InputLabel>
                    <Select
                      id="rain-select-month"
                      value={monthSelect}
                      onChange={this.handleMonthChange}
                      inputProps={{
                        name: 'monthSelect',
                        id: 'monthSelect',
                      }}
                    >
                      <MenuItem value="01">{t('มกราคม')}</MenuItem>
                      <MenuItem value="02">{t('กุมภาพันธ์')}</MenuItem>
                      <MenuItem value="03">{t('มีนาคม')}</MenuItem>
                      <MenuItem value="04">{t('เมษายน')}</MenuItem>
                      <MenuItem value="05">{t('พฤษภาคม')}</MenuItem>
                      <MenuItem value="06">{t('มิถุนายน')}</MenuItem>
                      <MenuItem value="07">{t('กรกฏาคม')}</MenuItem>
                      <MenuItem value="08">{t('สิงหาคม')}</MenuItem>
                      <MenuItem value="09">{t('กันยายน')}</MenuItem>
                      <MenuItem value="10">{t('ตุลาคม')}</MenuItem>
                      <MenuItem value="11">{t('พฤศจิกายน')}</MenuItem>
                      <MenuItem value="12">{t('ธันวาคม')}</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              )}

              {(type === 'rainfallMonth') && (
                <Grid item xs={6} sm={6} md={3}>
                  <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="type">{t('ปี')}</InputLabel>
                    <Select
                      id="rain-select-year"
                      value={yearSelect}
                      onChange={this.handleYearChange}
                      inputProps={{
                        name: 'yearSelect',
                        id: 'yearSelect',
                      }}
                    >
                      {years.map((y) => (
                        <MenuItem key={y} value={y}>{y}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              {(type === 'rainfallYear') && (
                <Grid item xs={6} sm={6} md={3}>
                  <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="type">{t('ปี')}</InputLabel>
                    <Select
                      id="rain-select-year"
                      value={yearSelect}
                      onChange={this.handleYearChange}
                      inputProps={{
                        name: 'yearSelect',
                        id: 'yearSelect',
                      }}
                    >
                      {yearsForRainfallYearly.map((y) => (
                        <MenuItem key={y} value={y}>{y}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              )}

              {(type === 'rainfallYesterday' || type === 'rainfall3day' || type === 'rainfall7day') && (
                <Grid item xs={6} sm={6} md>
                  <FormControl className={classes.formControl}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        id="rain-start-date"
                        label={t('วันที่เริ่มต้น')}
                        format="YYYY-MM-DD"
                        value={startDate}
                        maxDate={moment(today).subtract(1, 'days')}
                        onChange={this.handleStartDateChange}
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                </Grid>
              )}

              {(type === 'rainfallYesterday' || type === 'rainfall3day' || type === 'rainfall7day') && (
                <Grid item xs={6} sm={6} md>
                  <FormControl className={classes.formControl}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <DatePicker
                        id="rain-end-date"
                        label={t('วันที่สิ้นสุด')}
                        format="YYYY-MM-DD"
                        value={endDate}
                        maxDate={moment(today).subtract(1, 'days')}
                        onChange={this.handleEndDateChange}
                      />
                    </MuiPickersUtilsProvider>
                  </FormControl>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item xs sm={2}>
            <FormControl className={classes.formControl}>
              <Button id="rain-chart-btn" variant="outlined" color="primary" size="small" className={classes.button} onClick={this.renderChart} title={t('แสดงกราฟ')}>
                {t('แสดง')}
              </Button>
            </FormControl>
          </Grid>
          {isLoading && (
            <div className="text-center">
              loading
              {/* <FaSpinner size={20} /> */}
            </div>
          )}
          <Grid item xs={12}>
            {chart}
          </Grid>
        </Grid>
      </>
    );
  }
}

RainfallChart.propTypes = {
  classes: PropTypes.objectOf(PropTypes.any).isRequired,
  id: PropTypes.number.isRequired,
  provinceId: PropTypes.string.isRequired,
  selectedType: PropTypes.string.isRequired,
  filterData: PropTypes.instanceOf(Array).isRequired,
  year: PropTypes.string.isRequired,
  month: PropTypes.string.isRequired,
};

export default withTranslation()(RainfallChart);
